import {
	GET_COMPANY_SETTINGS,
	GET_COMPANY_SETTINGS_ERROR,
    GET_COMPANY_SETTINGS_SUCCESS,
} from '../../constants';

export const getCompanySettingReducer = (state, actions) => {
	switch (actions.type) {
		case GET_COMPANY_SETTINGS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_COMPANY_SETTINGS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_COMPANY_SETTINGS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				companies: actions.payload,
			};
		default:
			return state;
	}
};
